require('./shippingAddress.scss');

// @vendors
const PropTypes = require('prop-types');
const React = require('react');
const { isEmpty } = require('lodash');
const classnames = require('classnames');

// @core
const { FormattedText, formatText } = require('core/i18n').i18n;

// @utilitits
const { capitalize } = require('utilities/stringHelper');
const { getFormatedShippingAddress } = require('utilities/cardsHelper');

// @constants
const { getTranslatedCountry } = require('constants/countries');
const { getTranslatedRoad } = require('constants/typeOfRoads');
const { ES_COUNTRY } = require('constants/flagBasedFeatures');
const PROVINCES = require('constants/provinces');

// @components
const { HireContactDataForm } = require('components/hireContactDataForm/hireContactDataForm');
import FeatureTogglingRender from 'components/conditionalRender/featureTogglingRender';
const { OKMessage } = require('commonsComponents/OKMessage');
const { OKLink } = require('commonsComponents/OKLink');
import { isPrintOfficeMode } from 'utilities/contactCenter/printerHelper';


// @hocs
import withFeatureToggling from 'hocs/withFeatureToggling/withFeatureToggling';
const iconTips = require("./tips.svg");

// @constants
const {
    CORRESPONDENCE_ADDRESS_CODE,
    CORRESPONDENCE_ADDRESS_TYPE,
    LAST_ADDED_SHIPPING_ADDRESS_CODE,
    LAST_ADDED_SHIPPING_ADDRESS_TYPE,
    NEW_SHIPPING_ADDRESS,
    PERMANENT_ADDRESS_CODE,
    PERMANENT_ADDRESS_TYPE
} = require('constants/shippingAddress');


class ShippingAddress extends React.Component {
    constructor(props) {
        super(props);
        this.buildAddressCards = this.buildAddressCards.bind(this);
        this.handleAddressSelection = this.handleAddressSelection.bind(this);
    }

    handleAddressSelection(addressType, shippingAddress = {}) {
        const { immHireContactData, setShippingAddress } = this.props;
        let shippingAddressMapping = {}
        if (!isEmpty(shippingAddress)) {
            shippingAddressMapping = getFormatedShippingAddress(shippingAddress);
        } else {
            shippingAddressMapping = immHireContactData.get('isValid') ? immHireContactData
                : shippingAddress;
        }
        setShippingAddress(addressType, shippingAddressMapping);
    }

    shippingAddressContent = (immAddress, title) => {
        if (immAddress && immAddress.get('codFormatoDomicilio') === 'EXT') {
            return this.shippingAddressContentExt(immAddress, title)
        } else {
            return this.shippingAddressContentEsp(immAddress, title);
        }
    }

    shippingAddressContentExt(addressObject, title) {
        let postalCode;
        let addressLine2NoPostalCode;
        const address = addressObject.get('domicilioExt');
        const country = capitalize(getTranslatedCountry(address.get('pais')));
        const addressLine1 = capitalize(address.get('linea1Direccion') || '').trim();
        const addressLine2 = capitalize(address.get('linea2Direccion') || '').trim();

        postalCode = addressLine2.split(' ').pop().trim();
        addressLine2NoPostalCode = addressLine2.split(' ').slice(0, -1).join(' ').trim();

        if (postalCode.length <= 2) {
            const postalCodeNumbers = addressLine2NoPostalCode.split(' ').pop();
            const postalCodeLetters = postalCode;
            addressLine2NoPostalCode = addressLine2NoPostalCode.split(' ').slice(0, -1).join(' ').trim();
            postalCode = `(${postalCodeNumbers} ${postalCodeLetters})`;
        }

        const addressCity = capitalize(address.get('plaza') || '').trim();
        return (
            <div className="shipping-address__address-content">
                <h4 className="shipping-address__address-content-title">{title}</h4>
                <div className="shipping-address__address-description">
                    <span>{addressLine1} {addressLine2NoPostalCode},</span>
                </div>
                <div className="shipping-address__address-description">
                    <span>{postalCode}, {addressCity} </span>
                </div>
                <div>
                    <span>{country}</span>&nbsp;
                </div>
            </div>
        )
    }

    shippingAddressContentEsp(addressObject, title) {
        const address = addressObject.get('domicilioEsp');
        const country = capitalize(getTranslatedCountry(address.getIn(['pais'])));
        const province = PROVINCES[address.getIn(['plaza', 'provincia'])];
        const typeOfRoad = getTranslatedRoad(address.getIn(['tipoVia']));
        return (
            <div className="shipping-address__address-content">
                <h4 className="shipping-address__address-content-title">{title}</h4>
                <div className="shipping-address__address-description">
                    <span>{typeOfRoad}</span>&nbsp;
                    <span>{capitalize(address.getIn(['nombreVia']))}</span>
                    <span>{address.getIn(['numeroVia'])},</span>
                </div>
                <div className="shipping-address__address-description">
                    <span>{address.getIn(['anexoVia'])}</span>
                    <span>{capitalize(address.getIn(['localidad']))},</span>
                    <span>{province},</span>
                </div>
                <div>
                    <span>{country}</span>&nbsp;
                    <span>({address.getIn(['codigoPostal'])})</span>
                </div>
            </div>
        )
    }

    buildAddressCards() {
        const { immShippingAddressList } = this.props;
        let shippingAddressBlock;
        let correspondenceAddressBlock;
        let permanentAddressBlock;
        const shippingAddressList = immShippingAddressList.getIn(['shippingAddressList', 'domicilios']);
        const shippingAddressType = immShippingAddressList.get('shippingAddressType');
        const permanentAddressTitle = <FormattedText value="cardShippingAddress-cardShippingAddress_permanentAddressTitle" />;
        const correspondenceAddressTitle = <FormattedText value="cardShippingAddress-cardShippingAddress_correspondenceAddressTitle" />;
        const lastAddredShippingAddressTitle = <FormattedText value="cardShippingAddress-cardShippingAddress_shippingAddressTitle" />;

        if (shippingAddressList) {
            const permanentAddress = shippingAddressList.find((obj) => {
                return obj.get('tipoDomicilio') === PERMANENT_ADDRESS_CODE;
            });
            const correspondenceAddress = shippingAddressList.find((obj) => {
                return obj.get('tipoDomicilio') === CORRESPONDENCE_ADDRESS_CODE;
            });
            const lastAddedShippingAddress = shippingAddressList.find((obj) => {
                return obj.get('tipoDomicilio') === LAST_ADDED_SHIPPING_ADDRESS_CODE;
            });
            const selectionIcon = (<i className="icon-exito shipping-address__select-icon"></i>);
            if (permanentAddress) {
                const permanentAddressClass = classnames('col-sm-6 shipping-address__address-card', {
                    'shipping-address__highlight-address-card': shippingAddressType === PERMANENT_ADDRESS_TYPE
                });
                permanentAddressBlock = (
                    <div className={permanentAddressClass} onClick={() => {
                        this.handleAddressSelection(PERMANENT_ADDRESS_TYPE, permanentAddress);
                    }}>
                        {shippingAddressType === PERMANENT_ADDRESS_TYPE && selectionIcon}
                        {this.shippingAddressContent(permanentAddress, permanentAddressTitle)}
                    </div>
                )
            }
            if (correspondenceAddress) {
                const correspondenceAddressClass = classnames('col-sm-6 shipping-address__address-card', {
                    'shipping-address__highlight-address-card': shippingAddressType === CORRESPONDENCE_ADDRESS_TYPE
                });
                correspondenceAddressBlock = (
                    <div className={correspondenceAddressClass} onClick={() => {
                        this.handleAddressSelection(CORRESPONDENCE_ADDRESS_TYPE, correspondenceAddress);
                    }}>
                        {shippingAddressType === CORRESPONDENCE_ADDRESS_TYPE && selectionIcon}
                        {this.shippingAddressContent(correspondenceAddress, correspondenceAddressTitle)}
                    </div>
                )
            }
            if (lastAddedShippingAddress) {
                const shippingAddressClass = classnames('col-sm-6 shipping-address__address-card', {
                    'shipping-address__highlight-address-card': shippingAddressType === LAST_ADDED_SHIPPING_ADDRESS_TYPE
                });
                shippingAddressBlock = (
                    <div className={shippingAddressClass} onClick={() => {
                        this.handleAddressSelection(LAST_ADDED_SHIPPING_ADDRESS_TYPE, lastAddedShippingAddress);
                    }}>
                        {shippingAddressType === LAST_ADDED_SHIPPING_ADDRESS_TYPE && selectionIcon}
                        {this.shippingAddressContent(lastAddedShippingAddress, lastAddredShippingAddressTitle)}
                    </div>
                )
            }
            shippingAddressBlock = (
                <React.Fragment>
                    {permanentAddressBlock}
                    <FeatureTogglingRender notAllowedProductKey={ES_COUNTRY} >
                        {correspondenceAddressBlock}
                        {shippingAddressBlock}
                    </FeatureTogglingRender>
                </React.Fragment>
            )
            return (
                shippingAddressBlock
            )
        }
    }

    buildAddAddressButton() {
        const { immShippingAddressList } = this.props;
        const selectionIcon = (<i className="icon-exito shipping-address__select-icon"></i>);
        const shippingAddressType = immShippingAddressList.get('shippingAddressType');
        const addAddressClass = classnames('col-sm-6 shipping-address__add-address-btn', {
            'shipping-address__add-address-btn--disabled': shippingAddressType === NEW_SHIPPING_ADDRESS
        });
        return (
            <div className={addAddressClass} onClick={() => {
                this.handleAddressSelection(NEW_SHIPPING_ADDRESS)
            }} >
                {shippingAddressType === NEW_SHIPPING_ADDRESS && selectionIcon}
                <div className="col-sm-2 icon-agregar shipping-address__plus-logo" />
                <div className="col-sm-10 shipping-address__address">
                    <p className="shipping-address__add-address-title"><FormattedText value="cardShippingAddress-cardShippingAddress_addShippingAddressTitle" /></p>
                    <p className="shipping-address__add-address-content"><FormattedText value="cardShippingAddress-cardShippingAddress_addShippingAddressContent" /></p>
                </div>
            </div>
        )
    }
    buildIcon() {

        return (
            <img
                className="devices-grid__unknonw-disclaimer__icon__img"
                src={iconTips}
            />
        )
    }

    render() {
        const { immHireContactData, immShippingAddressList, infoBlock } = this.props;
        const buildAddressCardsLayout = this.buildAddressCards();
        const addAddressButton = this.buildAddAddressButton();
        const iconInformative = this.buildIcon();
        const shippingAddressType = immShippingAddressList.get('shippingAddressType');
        const disclaimerPersonalInfoUrl = formatText('hireCardNeruda-hireCardNeruda_disclaimerPersonalInfoLinkUrlNeruda');

        let contactDataForm = null;
        let shippingAddress = (
          <div className="row shipping-address__cards">
            {buildAddressCardsLayout}
            <FeatureTogglingRender notAllowedProductKey={ES_COUNTRY}>
              {addAddressButton}
            </FeatureTogglingRender>
          </div>
        );

        if (shippingAddressType === NEW_SHIPPING_ADDRESS) {
            contactDataForm = (
                <div className="col-sm-12 shipping-address__form-container">
                    <HireContactDataForm
                        immHireContactData={immHireContactData}
                        prepopulate={false}
                        showMobileDataForm={false}
                        showSubHeader={false}
                        emptyFields={true}
                    />
                </div>
            );
        }

        return (
            <article className="row shipping-address">
                <div className="col-sm-12">
                    <FormattedText
                        className="shipping-address__title"
                        value="cardShippingAddress-cardShippingAddress_title"
                    />
                    <h4 className="shipping-address__sub-title">
                        <FormattedText value="cardShippingAddress-cardShippingAddress_subTitle" />
                    </h4>
                    { __CONTACT_CENTER__ && shippingAddress}
                    {infoBlock &&
                        <div className="shipping-address__tips-container">
                            <OKMessage type="informative" customSizeModifier={'small'} customIcon={!__CONTACT_CENTER__ && iconInformative} modifier={__CONTACT_CENTER__ ? '' : 'icon-tips'}>
                                <FormattedText value={__CONTACT_CENTER__ && isPrintOfficeMode() ? 'cc_hireNewCreditCard-infoBlockStep2' : 'hireNewCreditCard-infoBlockStep2'} />
                            </OKMessage>
                        </div>

                    }
                    {!__CONTACT_CENTER__ && !isPrintOfficeMode() && shippingAddress}
                </div>

                {contactDataForm}

                {infoBlock && !__CONTACT_CENTER__ && !isPrintOfficeMode() &&
                    <div className="col-sm-12">

                        <div className="shipping-address__info-container">

                            <OKMessage type="informative">
                                <FormattedText value={'hireCardNeruda-hireCardNeruda_disclaimerPersonalInfoMsgNeruda'} />
                                &nbsp;
                                <OKLink modifier="emphasize" to={disclaimerPersonalInfoUrl} target="_blank">
                                    <FormattedText value={'hireCardNeruda-hireCardNeruda_disclaimerPersonalInfoLinkTextNeruda'} />
                                </OKLink>
                            </OKMessage>
                        </div>
                    </div>

                }

            </article>
        );
    }
}

ShippingAddress.propTypes = {
    flagBasedFeatures: PropTypes.object.isRequired,
    immHireContactData: PropTypes.object,
    immShippingAddressList: PropTypes.object,
    setShippingAddress: PropTypes.func
};

module.exports = withFeatureToggling(ShippingAddress);
